<div class="program-wrap" [ngClass]="{embedded: embedded}">
    <div class="title my-color-blue content-wrap-inner">
        <strong>{{programDelegate.program.title}}</strong>
    </div>

    <div class="blue-bg" *ngIf="programDelegate">
        <div class="content-wrap-inner">
            <div class="line">
                <div class="my-color-blue">{{'__JOURNEY_DATE__' | translate}}</div>
                <div class="text">{{programDelegate.program.program_dates}}</div>
            </div>
            <div class="line">
                <div class="my-color-blue">{{'__JOURNEY_TIME__' | translate}}</div>
                <div class="text">{{programDelegate.program.time}}</div>
            </div>
            <div class="line line-break">
                <div class="my-color-blue">{{'__JOURNEY_VENUE__' | translate}}</div>
                <div class="list-line">
                    <span *ngIf="programDelegate.program.venue.name">{{programDelegate.program.venue.name}}</span>
                    <span *ngIf="programDelegate.program.venue.contact_name">{{programDelegate.program.venue.contact_name}}</span>
                    <span *ngIf="programDelegate.program.venue.email">{{programDelegate.program.venue.email}}</span>
                    <span *ngIf="programDelegate.program.venue.addr1">{{programDelegate.program.venue.addr1}}</span>
                    <span *ngIf="programDelegate.program.venue.addr2">{{programDelegate.program.venue.addr2}}</span>
                    <span *ngIf="programDelegate.program.venue.addr3">{{programDelegate.program.venue.addr3}}</span>
                    <span *ngIf="programDelegate.program.venue.addr4">{{programDelegate.program.venue.addr4}}</span>
                    <span *ngIf="programDelegate.program.venue.post">{{programDelegate.program.venue.post}}</span>
                </div>
            </div>
        </div>
    </div>
</div>
